module.exports = __webpack_public_path__ + "img/Weapon_149.cafc72bf.png";